import React from 'react';
import {Link} from 'react-router-dom';
import {useSelector} from 'react-redux';

const LandingNav = () => {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated)
    || localStorage.getItem('authenticated') === 'true';

  return (
    <nav className="landing-nav">
        <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Manzili Smart" style={{height: 70, maxWidth: '100%'}}/>
      {isAuthenticated ? (
        <Link to="/dashboard" className="nav-cta">Dashboard →</Link>
      ) : (
        <Link to="/login" className="nav-cta">Login</Link>
      )}
    </nav>
  );
};

export default LandingNav;
